<template>
  <input-select
    id="languagePreference"
    :value="value"
    name="languagePreference"
    label="Preferred Language"
    placeholder="English is Fine"
    placeholder-enabled
    :options="options"
    display-field="name"
    @input="(val) => $emit('input', val)"
  />
</template>

<script>
import UserClient from '@/api/UserClient';
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'LanguagePicker',

  components: {
    InputSelect
  },

  props: {
    value: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      userClient: new UserClient(this.$http),

      options: []
    };
  },

  async mounted() {
    const languages = await this.userClient.getLanguagesList();
    this.options = languages.filter((l) => l.name !== 'English');
  }
};
</script>
